/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type CommitBuildRuleChangesInput = {|
  greenMachineSessionId: string,
  buildRuleChanges: $ReadOnlyArray<?BuildRuleChangeInput>,
  clientMutationId?: ?string,
|};
export type BuildRuleChangeInput = {|
  buildRuleId: string,
  status: boolean,
|};
export type CommitBuildRuleChangesMutationVariables = {|
  input: CommitBuildRuleChangesInput
|};
export type CommitBuildRuleChangesMutationResponse = {|
  +commitBuildRuleChanges: ?{|
    +success: ?boolean
  |}
|};
export type CommitBuildRuleChangesMutation = {|
  variables: CommitBuildRuleChangesMutationVariables,
  response: CommitBuildRuleChangesMutationResponse,
|};
*/


/*
mutation CommitBuildRuleChangesMutation(
  $input: CommitBuildRuleChangesInput!
) {
  commitBuildRuleChanges(input: $input) {
    success
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "CommitBuildRuleChangesPayload",
    "kind": "LinkedField",
    "name": "commitBuildRuleChanges",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "success",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "CommitBuildRuleChangesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "CommitBuildRuleChangesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "1143464685b23ee1289a960aa0ffd809",
    "id": null,
    "metadata": {},
    "name": "CommitBuildRuleChangesMutation",
    "operationKind": "mutation",
    "text": "mutation CommitBuildRuleChangesMutation(\n  $input: CommitBuildRuleChangesInput!\n) {\n  commitBuildRuleChanges(input: $input) {\n    success\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '63e5cd955ef50803565c2ac3506a8713';

module.exports = node;
